import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 9,
    fontFamily: "Helvetica",
  },
  header: {
    fontSize: 16,
    letterSpacing: 2,
  },
  topSection: {
    flexDirection: "row",
    marginBottom: 10,
    marginTop: 10,
  },
  leftSection: {
    flex: 1,
  },
  rightBox: {
    width: 300,
    border: "2px solid #000",
    padding: 8,
  },
  infoRow: {
    flexDirection: "row",
    marginBottom: 8,
    alignItems: "center",
  },
  label: {
    fontSize: 9,
    marginRight: 5,
  },
  underline: {
    flex: 1,
    borderBottom: "1px solid #000",
    height: 10,
  },
  filledText: {
    fontSize: 9,
    marginLeft: 3,
  },
  tableContainer: {
    border: "2px solid #000",
    marginBottom: 10,
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: "2px solid #000",
    backgroundColor: "#ffffff",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #000",
  },
  lastRow: {
    flexDirection: "row",
  },
  cell: {
    padding: 4,
    borderRight: "1px solid #000",
    justifyContent: "center",
    alignItems: "center",
  },
  lastCell: {
    padding: 4,
    justifyContent: "center",
    alignItems: "center",
  },
  cellText: {
    fontSize: 7,
    textAlign: "center",
  },
  boldText: {
    fontSize: 7,
    textAlign: "center",
  },
  providerRow: {
    flexDirection: "row",
    marginBottom: 6,
    alignItems: "center",
  },
  providerLabel: {
    fontSize: 9,
    width: 130,
  },
  providerUnderline: {
    flex: 1,
    borderBottom: "1px solid #000",
    height: 10,
    marginRight: 10,
  },
  titleSection: {
    flexDirection: "row",
    alignItems: "center",
  },
  titleLabel: {
    fontSize: 9,
    marginLeft: 10,
  },
  signatureRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  signatureLabel: {
    fontSize: 9,
    width: 150,
  },
  signature: {
    width: 100,
  },
  providerIdLabel: {
    fontSize: 9,
  },
  notesTable: {
    border: "2px solid #000",
  },
  notesHeader: {
    flexDirection: "row",
    borderBottom: "2px solid #000",
    backgroundColor: "#ffffff",
  },
  notesHeaderText: {
    fontSize: 8,
    textAlign: "center",
  },
  notesRow: {
    flexDirection: "row",
    borderBottom: "1px solid #000",
    minHeight: 25,
  },
  notesLastRow: {
    flexDirection: "row",
    minHeight: 25,
  },
  notesNumberCell: {
    width: 30,
    borderRight: "1px solid #000",
    padding: 3,
  },
  notesDateCell: {
    width: 80,
    borderRight: "1px solid #000",
    padding: 3,
  },
  notesTextCell: {
    flex: 1,
    padding: 3,
  },
  timeText: {
    fontSize: 6,
    textAlign: "center",
  },
  noteText: {
    fontSize: 7,
  },
  providerSection: {
    borderTop: "2px solid #000",
    borderRight: "2px solid #000",
    borderLeft: "2px solid #000",
    padding: "8px 4px",
  },
  notesTextCellSign: {
    width: 60,
  },
  noteTextCellSignRow: {
    marginTop: 3,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  notesTextCellInitials: {
    width: 50,
  },
});
